import React from "react";
import { FaGraduationCap } from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";

const Education = () => {
  const educationDetails = [
    {
      title: "M.Sc (I.T)",
      year: "2022-2024",
      description:
        "Dhirubhai Ambani Institute of Information and Communication Technology.",
      location: "Gandhinagar, Gujarat",
    },
    {
      title: "B.Sc (I.T)",
      year: "2019-2022",
      description:
        "J.P. Dawer Institute of Information Science and Technology.",
      location: "Surat, Gujarat",
    },
    {
      title: "HSC (12th Standard)",
      year: "2018-2019",
      description: "Specialized in Commerce field.",
      location: "Surat, Gujarat",
    },
    {
      title: "SSC (10th Standard)",
      year: "2016-2017",
      description: "Completed SSC from GSEB.",
      location: "Surat, Gujarat",
    },
  ];

  return (
    <div className="pt-12  rounded-xl shadow-lg">
      <h2 className="text-4xl font-bold text-[#e2e8f0] mb-12 text-center relative orbitron">
        Education
        <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-20 h-1 bg-gradient-to-r from-transparent via-[#94a3b8] to-transparent"></span>
      </h2>

      <div className="space-y-8 relative">
        {/* Timeline line */}
        <div className="absolute left-8 top-0 h-full w-0.5 bg-[#64748b]"></div>

        {educationDetails.map((edu, index) => (
          <div
            key={index}
            className="relative flex items-start md:gap-6 gap-3 md:pl-12 pl-11 group transition-all duration-300 hover:translate-x-2"
          >
            {/* Timeline dot */}
            <div className="absolute md:left-6 left-7 top-4 md:w-5 w-3 md:h-5 h-3 rounded-full bg-[#1e293b] border-4 border-[#64748b] group-hover:border-[#e2e8f0] transition-all duration-300 z-10"></div>

            <div className="md:text-3xl text-xl  text-[#64748b] group-hover:text-[#e2e8f0] transition-all duration-300 md:mt-1 mt-2.5 ">
              <FaGraduationCap />
            </div>

            <div className="flex-1 bg-[#0f172a] p-6 rounded-lg shadow-md border-l-4 border-[#64748b] group-hover:border-[#e2e8f0] transition-all duration-300">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                <div>
                  <h3 className="md:text-2xl text-xl font-bold text-[#e2e8f0] orbitron">
                    {edu.title}
                  </h3>
                  <p className="md:text-lg text-base text-[#94a3b8] mt-2 philosopher-6">
                    {edu.description}
                  </p>
                  <div className="flex items-center text-[#94a3b8] mt-3">
                    <MdLocationOn className="text-[#64748b] mr-2 md:text-xl text-lg" />
                    <span className="max-md:text-sm philosopher-5">
                      {edu.location}
                    </span>
                  </div>
                </div>

                <div className="px-4 py-2 bg-[#1e293b] rounded-md text-[#e2e8f0] font-semibold md:text-lg text-base min-w-max self-start md:self-center philosopher-6">
                  {edu.year}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Education;